import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data
    return [
      ...data.vaxiom_persons.map(person => ({
        ...person,
        id: person._id,
        vaxiom_id: person.id,
        address: person.contact_method_associations?.[0]?.postal_address,
        type: 'person',
      })),
      ...data.leads_leads.map(lead => ({
        ...lead,
        type: 'lead',
      })),
    ]
  }, [data])
}
